import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// La pagina del progetto (pages/ProjectDetail.js, 31a5bd1): apriPasso, apriDaRiepilogo, analizza e il segnale che apre
// la finestra dei dati dell'impresa (apreFinestra di lib/passi.js, setApriImpresa).
//
// apriPasso: i passi 1, 3 e 4 si mostrano qui, 0 è il Riepilogo. L'evento "apri-passo:apri" ({ n }) della testata, della
// barra dei passi e dei pulsanti del riepilogo arriva fin qui: per 0, 1, 3 e 4 la pagina lo annulla (onApri che rende
// true, contratto di apri_passo_controller.js) e apre lei l'indirizzo con una visita Turbo che sostituisce la voce della
// cronologia (setSearchParams(…, { replace: true })) e torna in alto; la pagina si rende di nuovo con il nuovo `attivo`
// (passo segnato, «Sei qui»/«Vai», Riepilogo). Gli altri passi (2, 5, 6) non si annullano: la testata apre la loro pagina.
// Lo stesso passo già aperto non cambia pagina: in alto, o (passo 1) la finestra se manca un dato, altrimenti la scheda
// dell'impresa in vista.
//
// Segnale per il Task 54 (ImpresaCard): l'evento "pagina-progetto:apri-impresa" su window ({ campo }: il primo dato
// mancante) quando la finestra dei dati dell'impresa deve aprirsi: arrivando al passo 1 con apreFinestra (anche al
// primo caricamento di ?passo=1, come l'effetto su project.id), ripremendo il passo 1, o con «Vai al campo». Una volta
// per arrivo, dopo che i controller della pagina si sono collegati.
//
// analizza: con dati del passo 1 mancanti mostra l'avviso (target `avviso`); altrimenti manda
// "pagina-progetto:analizza" su window per la finestra di analisi (Task 60, AnalyzeModal).
const PASSI_PAGINA_PROGETTO = [1, 3, 4]

// l'arrivo al passo 1 da apriPasso (la scheda in vista, 50 ms dopo) o da «Vai al campo» (la finestra comunque)
let arrivo = null

export default class extends Controller {
  static targets = ["avviso"]
  static values = { id: String, passo: Number, apriImpresa: Boolean, campo: String }

  connect() {
    const a = arrivo?.n === this.passoValue ? arrivo : null
    arrivo = null
    if (this.passoValue !== 1) return
    if (this.apriImpresaValue || a?.impresa) this.timer = setTimeout(() => this.segnaleImpresa(), 0)
    else if (a) this.timer = setTimeout(() => this.schedaInVista(), 50)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  // apri-passo:apri (sincrono: preventDefault prima che apri_passo_controller visiti l'indirizzo)
  apri(event) {
    const n = event.detail?.n
    if (n !== 0 && !PASSI_PAGINA_PROGETTO.includes(n)) return
    event.preventDefault()
    this.apriPasso(n)
  }

  apriPasso(n, { impresa = false } = {}) {
    if (n === this.passoValue) {
      if (n === 1 && !impresa && !this.apriImpresaValue) return this.schedaInVista()
      if (n === 1) this.segnaleImpresa()
      window.scrollTo?.({ top: 0, behavior: "smooth" })
      return
    }
    arrivo = { n, impresa }
    const base = `/app/progetto/${encodeURIComponent(this.idValue)}`
    Turbo.visit(n === 0 ? base : `${base}?passo=${n}`, { action: "replace" })
  }

  analizza() {
    if (this.hasAvvisoTarget) this.avvisoTarget.hidden = false
    else this.dispatch("analizza", { target: window })    // piano 03 Task 60: AnalyzeModal
  }

  // «Vai al campo»: l'avviso si chiude, il passo 1 si apre con la finestra dei dati dell'impresa
  vaiAlCampo() {
    if (this.hasAvvisoTarget) this.avvisoTarget.hidden = true
    this.apriPasso(1, { impresa: true })
  }

  segnaleImpresa() {
    this.dispatch("apri-impresa", { target: window, detail: { campo: this.campoValue } })
  }

  schedaInVista() {
    document.querySelector('[data-testid="impresa-card"]')?.scrollIntoView?.({ behavior: "smooth", block: "start" })
  }
}
